import React, { useState } from 'react';
import { MessageCircle, X, Send, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { mockCompanyInfo } from '../mock';

export const LiveChat = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openWhatsApp = () => {
    const message = encodeURIComponent("Hello! I'm interested in La-Klin's security and cleaning services. Please provide more information.");
    window.open(`https://wa.me/${mockCompanyInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
    setIsOpen(false);
  };

  const callDirectly = () => {
    window.open(`tel:${mockCompanyInfo.phone}`, '_self');
    setIsOpen(false);
  };

  return (
    <>
      {/* Chat Widget */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 z-50 w-80 max-w-[calc(100vw-3rem)]">
          <Card className="shadow-2xl border-2 border-red-200">
            <CardHeader className="bg-red-600 text-white rounded-t-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <div className="w-8 h-8 bg-red-700 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-sm">L</span>
                  </div>
                  <div>
                    <CardTitle className="text-lg text-white">La-Klin Support</CardTitle>
                    <p className="text-red-100 text-sm">We're here to help!</p>
                  </div>
                </div>
                <Button
                  onClick={() => setIsOpen(false)}
                  className="bg-transparent hover:bg-red-700 p-1 h-auto w-auto"
                >
                  <X className="w-4 h-4 text-white" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="p-4 space-y-4">
              <div className="bg-gray-100 rounded-lg p-3">
                <p className="text-sm text-gray-700">
                  👋 Hello! How can we help you with our security and cleaning services today?
                </p>
              </div>
              
              <div className="space-y-3">
                <p className="text-sm text-gray-600 font-medium">Choose how you'd like to connect:</p>
                
                <Button
                  onClick={openWhatsApp}
                  className="w-full bg-green-600 hover:bg-green-700 text-white py-2"
                >
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Continue on WhatsApp
                </Button>
                
                <Button
                  onClick={callDirectly}
                  className="w-full bg-red-600 hover:bg-red-700 text-white py-2"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Call {mockCompanyInfo.phone}
                </Button>
                
                <Button
                  onClick={() => {
                    document.getElementById('quote')?.scrollIntoView({ behavior: 'smooth' });
                    setIsOpen(false);
                  }}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2"
                >
                  Get Free Quote
                </Button>
              </div>
              
              <div className="text-center pt-2 border-t">
                <p className="text-xs text-gray-500">
                  Available 24/7 for emergencies
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Floating Chat Button */}
      <div className="fixed bottom-6 right-6 z-40">
        <Button
          onClick={() => setIsOpen(!isOpen)}
          className="w-14 h-14 rounded-full bg-red-600 hover:bg-red-700 text-white shadow-2xl transition-all duration-300 hover:scale-110"
        >
          {isOpen ? <X className="w-6 h-6" /> : <MessageCircle className="w-6 h-6" />}
        </Button>
        
        {/* Notification Badge */}
        {!isOpen && (
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 rounded-full animate-pulse"></div>
        )}
      </div>

      {/* Floating WhatsApp Button (Alternative) */}
      <div className="fixed bottom-24 right-6 z-30">
        <Button
          onClick={openWhatsApp}
          className="w-12 h-12 rounded-full bg-green-600 hover:bg-green-700 text-white shadow-lg transition-all duration-300 hover:scale-105"
          title="Chat on WhatsApp"
        >
          <MessageCircle className="w-5 h-5" />
        </Button>
      </div>
    </>
  );
};